export default "__VITE_ASSET__CsfXCPHj__"